import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box} from 'views/components';

import JobDetails from './job_details/JobDetails';
import JobTitle from './title/JobTitle';
import JobDescription from './description/JobDescription';

const JobHeader = (props) => {
  const {
    jobData,
    client,
    jobBackend,
    refresh,
    setRefresh,
  } = props;
  return (
    <Stack gap={1}>
      <JobTitle
        jobData={jobData}
        client={client}
        jobBackend={jobBackend}
      />
      <JobDetails
        jobData={jobData}
        client={client}
        jobBackend={jobBackend}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <Box
        sx={{
          px: 2,
        }}
      >
        <JobDescription
          jobData={jobData}
          jobBackend={jobBackend}
        />
      </Box>
    </Stack>
  );
};
JobHeader.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
  jobBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(JobHeader);
